import { render } from "./FeaturedPool.vue?vue&type=template&id=26e06fff&scoped=true"
import script from "./FeaturedPool.vue?vue&type=script&lang=js"
export * from "./FeaturedPool.vue?vue&type=script&lang=js"

import "@/Common/Styles/featuredPool.scss?vue&type=style&index=0&id=26e06fff&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e06fff"]])

export default __exports__